export default __webpack_public_path__ + "static/13-ed589b116eff785cbc584c39550dd4bb.webp";